import BaseComponent from 'foundation/base-component';
import constants from './constants';
import creators from './actions';
import Scroller from '../../../general/js/scroller';

export default class PlayerRegistrationStep extends BaseComponent {
    constructor(...args) {
        super(...args);

        this.onChangeStoreBase = this.onChangeStoreBase.bind(this);
        this.onContinueClick = this.onContinueClick.bind(this);
        this.isStepValid = this.isStepValid.bind(this);

        this.number = parseInt(this.element.dataset.number, 10);
        this.isVisible = null;
    }

    getStepNumber() {
        return this.number;
    }

    init({ store, onContinue }) {
        this.store = store;
        this.onContinue = onContinue;
        this.store.dispatch(creators.registerStep(this.number));
        // split form to groups based on steps numbers
        const inputs = [...this.element.querySelectorAll(constants.PARSLEY_INCLUDE_SELECTOR)];
        inputs.forEach((inputNode) => {
            inputNode.setAttribute('data-parsley-group', this.number);
        });
        this.addListeners(inputs);
        this.initConcrete();
        this.applyStateBase(this.store.getState());
        this.applyStateConcrete(this.store.getState());
    }

    addListeners() {
        this.store.subscribe(this.onChangeStoreBase);
        if (this.refs.continue) {
            this.refs.continue.addEventListener('click', this.onContinueClick);
        }
    }

    getIsStepValidPromise() {
        return new Promise((resolve, reject) => {
            if (this.isStepValid() === false) {
                reject();
            } else {
                resolve();
            }
        });
    }

    onContinueClick() {
        this.onContinue();
    }

    onChangeStoreBase() {
        this.applyStateBase(this.store.getState());
        this.applyStateConcrete(this.store.getState());
    }

    applyStateBase({ step }) {
        if (this.isVisible === true && this.number !== step) {
            this.hide();
        } else if (this.isVisible === false && this.number === step) {
            this.show();
        } else if (this.isVisible === null) {
            this.hide();
        }
    }

    show() {
        this.isVisible = true;
        this.element.classList.remove('visually-hidden');
        (new Scroller(this.element, { duration: 300 })).scrollToTop(true);
    }

    hide() {
        this.isVisible = false;
        this.element.classList.add('visually-hidden');
    }

    initConcrete() {
    }

    applyStateConcrete() {
    }

    isStepValid() {
        return true;
    }
}
